//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapGetters } from 'vuex'
import draggable from 'vuedraggable'

export default {
  name: 'QuestionDetailView',
  components: {
    draggable
  },
  props: {
    // normal = full owner capabilities or readonly = questions can be viewed by participants but not answered
    mode: {
      type: String,
      default: 'normal'
    },
    // Expand All / Collapse All, forwarded from CategoriesQuestions
    visible: {
      type: Boolean,
      default: false
    },
    toggleKey: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
    }
  },
  computed: {
    ...mapGetters({
      activeCategory: 'questions/getActiveCategory',
      lastQuestionDeleted: 'questions/getLastQuestionDeleted',
      primaryCategory: 'questions/getPrimaryCategory',
      isActingAsReviewer: 'user/isActingAsReviewer',
      questionSearchMatcher: 'questions/getQuestionSearchMatcher',
      secondaryCategory: 'questions/getSecondaryCategory',
      questionDropTarget: 'questions/getQuestionDropTarget'
    }),
    calculatedMode() {
      return this.isActingAsReviewer ? 'readonly' : this.mode
    },
    questionList: {
      get() {
        return this.$store.state.questions.questions
      },
      set(questionList) {
        // A drop onto a sidebar category moves the question instead of reordering
        if (this.questionDropTarget) {
          return
        }
        this.updateQuestionList(questionList)
      }
    }
  },
  watch: {
    lastQuestionDeleted(newVal) {
      if (newVal) {
        this.refreshCategories()
      }
    }
  },
  mounted() {
    this.route = { ...this.$route.params }
    this.categoryOwner = this.route.templateid ? this.route.templateid : this.route.projectid
    this.categoryType = this.route.templateid ? 1 : 2
    if (this.isActingAsReviewer) {
      this.mode = 'readonly'
    }
  },
  beforeDestroy() {
    document.removeEventListener('dragover', this.onDragMove)
    document.removeEventListener('touchmove', this.onDragMove)
  },
  methods: {
    ...mapActions({
      fetchPrimaryCategories: 'questions/fetchPrimaryCategories',
      setLastQuestionDeleted: 'questions/setLastQuestionDeleted',
      updateQuestionList: 'questions/updateQuestionList',
      moveQuestionToCategory: 'questions/moveQuestionToCategory',
      setQuestionDrag: 'questions/setQuestionDrag'
    }),
    onDragStart() {
      this.setQuestionDrag({ active: true })
      document.addEventListener('dragover', this.onDragMove)
      document.addEventListener('touchmove', this.onDragMove)
    },
    // Tracks which sidebar category (Category.vue data-drop-* attributes) the
    // dragged question is over; the current category is not a target
    onDragMove(e) {
      const point = e.touches ? e.touches[0] : e
      const el = document.elementFromPoint(point.clientX, point.clientY)
      const targetEl = el && el.closest('[data-drop-primary]')
      let target = null
      if (targetEl) {
        const primary = targetEl.dataset.dropPrimary
        const secondary = targetEl.dataset.dropSecondary || ''
        if (primary !== this.primaryCategory || secondary !== (this.secondaryCategory || '')) {
          target = { primary, secondary }
          // allows the native drop (and its cursor) over the category
          if (e.type === 'dragover') {
            e.preventDefault()
          }
        }
      }
      const current = this.questionDropTarget
      if (!current !== !target || (target && (target.primary !== current.primary || target.secondary !== current.secondary))) {
        this.setQuestionDrag({ active: true, target })
      }
    },
    async onDragEnd(evt) {
      document.removeEventListener('dragover', this.onDragMove)
      document.removeEventListener('touchmove', this.onDragMove)
      const target = this.questionDropTarget
      this.setQuestionDrag({ active: false })
      if (!target) {
        return
      }
      const question = this.questionList[evt.oldIndex]
      const res = await this.moveQuestionToCategory({ question, ...target })
      if (res) {
        const destination = target.secondary ? `${target.primary} > ${target.secondary}` : target.primary
        this.$bvToast.toast(`Question moved to "${destination}"`, {
          autoHideDelay: 2000,
          noCloseButton: true,
          solid: true,
          toaster: 'b-toaster-top-right',
          title: 'Success',
          variant: 'success'
        })
      }
    },
    async refreshCategories() {
      await this.fetchPrimaryCategories({ owner: this.categoryOwner, type: this.categoryType })
      this.setLastQuestionDeleted(false)
      localStorage.removeItem('categoryselections')
      if (this.activeCategory === this.primaryCategory) {
        /*
          TODO: 2 issues:
          1) if primary deleted and there were NO secondaries under that category, we should
          update the localstorage to Uncategories and set the active category

          2) Bug exists if primary deleted and there ARE secondary categories associated. Secondaries
          are briefly showing up under Uncategorized, but they are not really there and once you
          start changing categories they disappear as secondaries under Uncategorized. At that point,
          you can't access the questions in these secondaries either. They become orphans unaccessible
          in CategoryQuestions. This is because they have no primary but still have a secondary assigned.
          I found this by going to Requirements tab and seeing some of the questions and was able to access
          them that way but there are likely alot of orphans questions in the db now with a secondary but no primary.
        */
      }
    }
  }
}
